export default __webpack_public_path__ + "static/bg2-91365e8bae0048fc81512db0ada3e284.jpg";